import { api } from "@/lib/api";

let token = null;
const subs = new Set();
export const getCassaToken = () => token;
export const setCassaToken = (t) => { token = t; subs.forEach((f) => f(t)); };
export const onCassaToken = (f) => { subs.add(f); return () => subs.delete(f); };

const cfg = (c = {}) => ({ ...c, headers: { ...(c.headers || {}), "X-Cassa-Token": token || "" } });
const wrap = (p) => p.catch((e) => { if (e?.response?.status === 423) setCassaToken(null); throw e; });
const B = "/admin/cassa";

export const cassa = {
  get: (u, c) => wrap(api.get(B + u, cfg(c))),
  post: (u, b, c) => wrap(api.post(B + u, b, cfg(c))),
  put: (u, b, c) => wrap(api.put(B + u, b, cfg(c))),
  delete: (u, c) => wrap(api.delete(B + u, cfg(c))),
};

export async function cassaDownload(u, filename) {
  const r = await cassa.get(u, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function cassaOpen(u) {
  const win = window.open("", "_blank");
  try {
    const r = await cassa.get(u, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    if (win) win.location.href = url; else window.location.href = url;
  } catch (e) { win?.close(); throw e; }
}

export const money = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(+n || 0);
export const num = (v) => { const x = parseFloat(String(v).replace(",", ".")); return Number.isFinite(x) ? x : 0; };
export const VATS = [22, 10, 5, 4, 0];
